var play_icon_default = {
  "shadow": "aHL3D",
  "playIcon": "_2MIJ7"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
